/**
 * @packageDocumentation
 * Renders the interactive instruction overlay that introduces the match conditions and advances into gameplay when the player taps to continue.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { dullFilter2, font_main, HandleOrientation } from "./Game/global";
import { gsap } from "gsap/gsap-core";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { SoundManager } from "./Game/sounds";

interface CardValues{
  text:string,
  img:string|undefined,
  id:string|undefined,
  X:number,
  Y:number,
  Image:string,
}
export class InstructionScreen extends PIXI.Container {

  private instructions = new PIXI.Container();
  private instructionLogo!: PIXI.Sprite;
  private instructionsArr:({
    text: string;
    id: string;
    img?: undefined;
} | {
    text: string;
    img: string;
    id: string;
})[] = [
      { text: "COLLECT 3 OF\n THE SAME\nCHARACTER", id:'1' },
      { text: "COLLECT 3 OF\n THE SAME\nBORDERS TO WIN", id:'3' },
      { text: "FLIP 3 SUPERHEROES\nTO UNLOCK \nTHE BONUS MISSION", id:'2' },
      { text: "", id:'3' },
]
 private instructionBg!:PIXI.Sprite;
  constructor(
    private app_width: number,
    private app_height: number,
    private onContinue: () => void
  ) {
    super();
    this.createInstructionBg();
    this.addChild(this.instructions)
    this.createInstruction();
    this.createRoboAnim();
    this.createFannedHeroFramePairs()
    this.buildBorderFrameFan();
    this.buildHeroFrameFan()
    this.createBox();
    this.createInstructionScreen()
    this.interactive = true;
    this.cursor = "pointer"; 
    this.on("pointertap", () => {
            // SoundManager.Btnclick_1SndPlay(); 
        this.onContinue();
      });
    HandleOrientation(this.PortraitAdjustFun.bind(this),this.landScapeAdjustFun.bind(this))

  }

  private createInstructionBg(){
    const bg = new PIXI.Sprite(Assets.get('startPage_popup'));
    const downText = new PIXI.Text({text:"CLICK ANYWHERE TO CONTINUE", style:{
      fill: '#ddb120ff',
              stroke: {
                color:'#000',
                width:5
              },
              fontSize: 40,
              fontFamily:'FranklinGothic-Demi'
    }})
    
    bg.x = this.app_width/2;
    bg.y = this.app_height/2 - (-116)+14;
    bg.anchor.set(0.5);
    bg.scale.set(0.8);
    this.addChild(bg); 
    this.instructionBg = bg;
 
    downText.x = this.app_width/2;
    downText.y = this.app_height /2 - (-310);
    downText.anchor.set(0.5);
    downText.scale.set(1);
    gsap.to(downText,{pixi:{scale:0.9},duration:1,repeat:-1,yoyo:true})
    this.addChild(downText);
  }
 

   private createInstructionScreen() {
   this.instructionLogo = new PIXI.Sprite(Assets.get("startPage_logo")); 
   this.instructionLogo.x = this.app_width / 2;
   this.instructionLogo.y = 153//this.app_height / 2 - 260+21;
   this.instructionLogo.anchor.set(0.5);
   this.instructionLogo.scale.set(0.43);
   this.addChild(this.instructionLogo);
  }

  private createInstructionBox(data:CardValues){
    const instructionBox = new PIXI.Container();
    instructionBox.x = data.X
    instructionBox.y = data.Y
    const card = new PIXI.Sprite(Assets.get(data.Image));
    card.scale.set(1);
    card.anchor.set(0.5);
    instructionBox.addChild(card);
    if(data.id == '2'){
      card.x=247.5
      // card.y=-89
    }
    //  if(data.Image){
    //   const imgs = new PIXI.Sprite(Assets.get(data.Image));
    //   imgs.x=-276
    //   imgs.y=-89
    //   imgs.scale.set(1.1,1)
    //   instructionBox.addChild(imgs);
    //   }

    if(data.img){
      const img = new PIXI.Sprite(Assets.get(data.img));
      if(data.id == '1'){
      img.anchor.set(0.5);
      img.x = card.x - 180;
      img.y = card.y + 5; 
      img.scale.set(1.1);

      }
      else if(data.id == '2'){
      img.anchor.set(0.5);
      img.x = card.x - 150;
      img.y = card.y - 50; 
      img.scale.set(0.6);
      }

      instructionBox.addChild(img);
    }

    const text = new PIXI.Text({
        text: data.text,
        style: {
          fontFamily: 'FranklinGothic-Demi',
          fontSize:(data.id=='1' || data.id=='2')?27:27,
          fill: "#4d1d1dff",
          align:data.id=='2'?'center':"center",
          wordWrap: true,
          wordWrapWidth: 1500,
        },
      });
      
      text.anchor.set(0.5);
      text.x = -80//card.x;
      text.y = card.y; 
      if(data.id == '1' || data.id ==''){
        text.x = card.x+100;
      }else if ( data.id =='2'){
        text.x=247.5+30
      }
     
      instructionBox.addChild(text);
    this.instructions.addChild(instructionBox);
  }

  private createInstruction(){  
    let Xpos = 0;
    let Ypos = 140;
   var name;
    for( let i = 0; i < 3; i++){ 
      name = i == 2 ? "landing_bg_box_big" : "startPage_card";

       Xpos+=500;
      if(i%2==0){
        Xpos=430;
        Ypos+=200;
      }
      const data = {text:this.instructionsArr[i].text,img:this.instructionsArr[i].img!, id:this.instructionsArr[i].id!,X:Xpos,Y:Ypos,Image:name}
      this.createInstructionBox(data);
  }

}

 private createRoboAnim(): void {
    const roboAnim = Spine.from({
      skeleton: "robo_anim_json",
      atlas: "robo_anim_atlas",
      scale: 2,
    });
    roboAnim.x = 950
    roboAnim.y = 579;
     roboAnim.rotation = 13 * (Math.PI / 180);
    // Play idle animation in a loop
    roboAnim.state.setAnimation(0, "lp_idle", true);
    roboAnim.state.timeScale = 0.8;
    roboAnim.scale.set(0.25);
    this.addChild(roboAnim);
  }
  
private createBox() {
  console.log("box creating...");
  const boxContainer = new PIXI.Container();
  boxContainer.x = 680;
  boxContainer.y = 340;
  boxContainer.pivot.set(0.5);
  const boxSprite = new PIXI.Sprite(Assets.get("lp_circle"));
  boxSprite.anchor.set(0.5);
  boxSprite.scale.set(1);
  const text = new PIXI.Text({
    text: "OR", // Replace with your actual text
    style: {
      fontFamily: 'FranklinGothic-Demi',
      fontSize: 30,
      fill: "#4d1d1dff", // White text
      align: "center"
    }
  });

  text.anchor.set(0.5); // Center text on its origin
  text.x = 0;
  text.y = 0;
  boxContainer.addChild(boxSprite);
  boxContainer.addChild(text);
  this.addChild(boxContainer);
}

private createFannedHeroFramePairs(): void {
  const pairConfigs = [
    {
      frame: { skeleton: "bronze_frame_anim_json", atlas: "bronze_frame_anim_atlas" },
      hero:  { skeleton: "Yellow_civilian_json",  atlas: "Yellow_civilian_atlas" },
      x:232,
      y: 401,
      rotation: -10,
    },
    {
      frame: { skeleton: "Gold_frame_anim_json", atlas: "Gold_frame_anim_atlas" },
      hero:  { skeleton: "Yellow_civilian_json",  atlas: "Yellow_civilian_atlas" },
      x: 317,
      y: 401,
      rotation: 10,
    },
       {
      frame: { skeleton: "Silver_frame_anim_json", atlas: "Silver_frame_anim_atlas" },
      hero:  { skeleton: "Yellow_superhero_json", atlas: "Yellow_superhero_atlas" },
      x: 269,
      y: 398,
      rotation: 0,
    },
  ];

  for (const cfg of pairConfigs) {
    const pairContainer = new PIXI.Container();
    pairContainer.x = cfg.x;
    pairContainer.y = cfg.y;
    pairContainer.rotation = cfg.rotation * (Math.PI / 180);
    const heroSpine = Spine.from({
      skeleton: cfg.hero.skeleton,
      atlas: cfg.hero.atlas,
      scale: 2,
    });
    heroSpine.scale.set(0.15);
    heroSpine.state.setAnimation(0, "idle_anim", true);
    heroSpine.state.timeScale = 0.8;
    pairContainer.addChild(heroSpine); 
 
    const frameSpine = Spine.from({
      skeleton: cfg.frame.skeleton,
      atlas: cfg.frame.atlas,
      scale: 2,
    });
    frameSpine.scale.set(0.15);
    frameSpine.y=-68
    frameSpine.state.setAnimation(0, "static", true);
    frameSpine.state.timeScale = 0.8;
    frameSpine.filters = [dullFilter2]
    pairContainer.addChild(frameSpine); 

    this.addChild(pairContainer);
  }
}
private buildBorderFrameFan(): void {
  const cardPairs = [
    {
      frameCfg: { skeleton: "Hologram_frame_anim_json", atlas: "Hologram_frame_anim_atlas" },
      heroCfg:  { skeleton: "Blue_civilian_json",  atlas: "Blue_civilian_atlas" },
      posX: 1050,
      posY: 401,
      angle: -10,
    },
    {
      frameCfg: { skeleton: "Hologram_frame_anim_json", atlas: "Hologram_frame_anim_atlas" },
      heroCfg:  { skeleton: "Purple_civilian_json",  atlas: "Purple_civilian_atlas" },
      posX: 1139,
      posY: 401,
      angle: 10,
    },
    {
      frameCfg: { skeleton: "Hologram_frame_anim_json", atlas: "Hologram_frame_anim_atlas" },
      heroCfg:  { skeleton: "Red_civilian_json", atlas: "Red_civilian_atlas" },
      posX: 1093,
      posY: 398,
      angle: 0,
    },
  ];

  for (const pair of cardPairs) {
    const cardContainer = new PIXI.Container();
    cardContainer.x = pair.posX;
    cardContainer.y = pair.posY;
    cardContainer.rotation = pair.angle * (Math.PI / 180);
    const heroCard = Spine.from({
      skeleton: pair.heroCfg.skeleton,
      atlas: pair.heroCfg.atlas,
      scale: 2,
    });
    heroCard.scale.set(0.15);
    heroCard.state.setAnimation(0, "idle_anim", true);
    heroCard.state.timeScale = 0.8;
    heroCard.filters = [dullFilter2]
    cardContainer.addChild(heroCard); 

    // --- frame (front) ---
    const frameCard = Spine.from({
      skeleton: pair.frameCfg.skeleton,
      atlas: pair.frameCfg.atlas,
      scale: 2,
    });
    frameCard.scale.set(0.15);
    frameCard.y = -68; // vertical offset
    frameCard.state.setAnimation(0, "static", true);
    frameCard.state.timeScale = 0.8;
    cardContainer.addChild(frameCard); 

    this.addChild(cardContainer);
  }
}
private buildHeroFrameFan(): void {
  const cardPairs = [
    {
      frameCfg: { skeleton: "bronze_frame_anim_json", atlas: "bronze_frame_anim_atlas" },
      heroCfg:  { skeleton: "Blue_superhero_json",  atlas: "Blue_superhero_atlas" },
      x:232+170,
      y: 381+220,
      rotation: -10,
    },
    {
      frameCfg: { skeleton: "Gold_frame_anim_json", atlas: "Gold_frame_anim_atlas" },
      heroCfg:  { skeleton: "Purple_superhero_json",  atlas: "Purple_superhero_atlas" },
      x: 317+170,
      y: 381+220,
      rotation: 10,
    },
    {
      frameCfg: { skeleton: "Silver_frame_anim_json", atlas: "Silver_frame_anim_atlas" },
      heroCfg:  { skeleton: "Red_superhero_json", atlas: "Red_superhero_atlas" },
      x: 269+170,
      y: 378+220,
      rotation: 0,    
    },
  ];

  for (const pair of cardPairs) {
    const cardContainer = new PIXI.Container();
    cardContainer.x = pair.x;
    cardContainer.y = pair.y;
    cardContainer.rotation = pair.rotation * (Math.PI / 180);
    const heroCard = Spine.from({
      skeleton: pair.heroCfg.skeleton,
      atlas: pair.heroCfg.atlas,
      scale: 2,
    });
    heroCard.scale.set(0.15);
    heroCard.state.setAnimation(0, "idle_anim", true);
    heroCard.state.timeScale = 0.8;
    cardContainer.addChild(heroCard); 

    // --- frame (front) ---
    const frameCard = Spine.from({
      skeleton: pair.frameCfg.skeleton,
      atlas: pair.frameCfg.atlas,
      scale: 2,
    });
    frameCard.scale.set(0.15);
    frameCard.y = -68; // vertical offset
    frameCard.state.setAnimation(0, "static", true);
    frameCard.state.timeScale = 0.8;
    frameCard.filters = [dullFilter2]
    cardContainer.addChild(frameCard);  
    this.addChild(cardContainer);
  }
}
  PortraitAdjustFun(){
    this.scale.set(0.475)
    this.position.set(354,228.5) 
    this.instructionLogo.scale.set(.7);
    this.instructionLogo.y = 56;
    this.instructionBg.x = this.app_width/2;
    this.instructionBg.y = 577 //587//this.app_height/2 - (-116)+14;
    this.instructionBg.scale.set(1);    
  }  
  landScapeAdjustFun(){
    this.scale.set(1)
    this.position.set(0)
    this.instructionLogo.scale.set(0.43);
    this.instructionLogo.y = 153;
    this.instructionBg.x = this.app_width/2;
    this.instructionBg.y = this.app_height/2 - (-116)+14;
    this.instructionBg.scale.set(0.8);
  }

}



  